export const navigateToProductListWithClusterAndGenre = ({
  history,
  clusters,
  genre,
}) => history.push(`/productList?clusters=${clusters}&genre=${genre}`);

export const navigateToProductListWithGenre = ({ history, genre }) => history.push(`/productList?genre=${genre}&clusters=${genre}`);

export const navigateToProductListWithClusters = ({ history, clusters }) => history.push(`/productList?clusters=${clusters}`);
